import React from 'react';
import { Button } from 'semantic-ui-react';

import './TextLinkButton.styles.css';

const TextLinkButton = ({ className, children, ...props }) => (
  <Button className={`textLinkButton ${className}`} {...props}>{children}</Button>
);

export default TextLinkButton;